import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ScopeViewOnly from '../shared/ScopeViewOnly';
import { SCOPE_LEVEL_UNITORUNITGROUP } from '../shared/AppConstants';
import MasterScope from './MasterScope';
import { getMissingSDFDisplay, getScope } from '../shared/UtilFunctions';
import {
  selectScopeInvalidError,
  selectScopeType,
  selectSelectedScopeUnits,
  selectSelectedScopeViewList,
  setScopeInvalidError,
  setSelectedScopeViewList
} from './Strategy/scopeSlice';

export default function ScopeWrapper(props) {
  const {
    hasUSScope,
    isEdit,
    masterScopeJson,
    strategyInformation,
    commonProps,
    register,
    strategyNumber,
    okToPublish
  } = props;
  const dispatch = useDispatch();
  const selectedScopeUnits = useSelector(selectSelectedScopeUnits);
  const selectedScopeViewList = useSelector(selectSelectedScopeViewList);
  const scopeType = useSelector(selectScopeType);
  const invalidError = useSelector(selectScopeInvalidError);

  const [enableEditScope, setEnableEditScope] = useState(null);
  const [enableViewScope, setEnableViewScope] = useState(null);

  function buildScopeViewSnapshot() {
    if (scopeType === SCOPE_LEVEL_UNITORUNITGROUP) {
      return getScope(SCOPE_LEVEL_UNITORUNITGROUP, selectedScopeUnits);
    }

    if (scopeType) {
      return {
        level: scopeType,
        unitGroups: [],
        units: []
      };
    }

    return null;
  }

  function hasAnyScopeSelectionInTree() {
    if (!Array.isArray(selectedScopeUnits) || selectedScopeUnits.length === 0) {
      return false;
    }

    return selectedScopeUnits.some(
      (group) =>
        group?.checked ||
        (Array.isArray(group?.children) &&
          group.children.some((unit) => unit?.checked))
    );
  }

  function editScope(e) {
    e.preventDefault();
    if (!selectedScopeViewList && strategyInformation?.scope) {
      dispatch(setSelectedScopeViewList(strategyInformation.scope));
    }
    setEnableEditScope(true);
    setEnableViewScope(false);
  }

  function viewScope(e) {
    e.preventDefault();
    const scopeSnapshot = buildScopeViewSnapshot();
    const hasTreeSelection = hasAnyScopeSelectionInTree();
    const hasNoScopeSelection =
      !scopeSnapshot?.level ||
      (scopeSnapshot.level === SCOPE_LEVEL_UNITORUNITGROUP &&
        (!scopeSnapshot.unitGroups || scopeSnapshot.unitGroups.length === 0) &&
        (!scopeSnapshot.units || scopeSnapshot.units.length === 0));

    if (hasNoScopeSelection && !hasTreeSelection) {
      dispatch(setScopeInvalidError('At least 1 Unit must be selected'));
      return;
    }

    if (scopeType === SCOPE_LEVEL_UNITORUNITGROUP && invalidError) {
      return;
    }

    if (scopeSnapshot) {
      dispatch(setSelectedScopeViewList(scopeSnapshot));
    }
    setEnableViewScope(true);
    setEnableEditScope(false);
  }

  function getLocalMissingSDFDisplay() {
    return getMissingSDFDisplay(hasUSScope, strategyInformation, okToPublish);
  }

  return (
    <>
      {props.isNewForm || enableEditScope || strategyNumber === 0 ? (
        <MasterScope
          key={selectedScopeViewList}
          masterScopeJson={masterScopeJson}
          register={register}
          isEdit={isEdit}
          missingScopeError={props.missingScopeError}
          invalidError={invalidError}
          viewScope={viewScope}
          hasUSScope={hasUSScope}
          strategyInformation={strategyInformation}
          getMissingSDFDisplay={getLocalMissingSDFDisplay}
          duplicateStrategyState={props.duplicateStrategyState}
          isNewForm={props.isNewForm}
        />
      ) : (
        (enableViewScope || strategyInformation) &&
        masterScopeJson && (
          <ScopeViewOnly
            key={selectedScopeViewList}
            editScope={editScope}
            isEdit={isEdit}
            strategyInformation={strategyInformation}
            selectedScopeViewList={selectedScopeViewList}
            masterData={masterScopeJson}
            commonProps={commonProps}
            hasUSScope={hasUSScope}
            enableViewScope={enableViewScope}
            selectedScopeUnits={selectedScopeUnits}
            getMissingSDFDisplay={getLocalMissingSDFDisplay}
            duplicateStrategyState={props.duplicateStrategyState}
          />
        )
      )}
    </>
  );
}
